import {Button} from '@/components/ui/button/Button'
import {CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {
    StyledBulkSiarExportDialogFooter,
    StyledBulkSiarExportResultBody,
    StyledBulkSiarExportResultIcon,
    StyledBulkSiarExportResultSubtitle,
    StyledBulkSiarExportResultTitle
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

type BulkSiarExportResultStepProps = {
    pendingCount: number
    onClose: () => void
}

export const BulkSiarExportResultStep = ({pendingCount, onClose}: BulkSiarExportResultStepProps) => {
    const {t} = useTranslation()

    return (
        <>
            <StyledBulkSiarExportResultBody>
                <StyledBulkSiarExportResultIcon>
                    <CheckCircleIcon size={48} />
                </StyledBulkSiarExportResultIcon>
                <StyledBulkSiarExportResultTitle>
                    {t('projects:bulk_siar_export_success_title')}
                </StyledBulkSiarExportResultTitle>
                <StyledBulkSiarExportResultSubtitle>
                    {t('projects:bulk_siar_export_success_subtitle', {count: pendingCount})}
                </StyledBulkSiarExportResultSubtitle>
            </StyledBulkSiarExportResultBody>
            <StyledBulkSiarExportDialogFooter>
                <Button variant="primaryNeutral" onClick={onClose}>
                    {t('commons:close')}
                </Button>
            </StyledBulkSiarExportDialogFooter>
        </>
    )
}
